import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import AddContact from './AddContact';
import AddContactList from './contact-lists/AddContactList';
import ShowContactList from './contact-lists/ShowContactList';
import ContactsHome from './Home';
import ShowContact from './ShowContact.container';
import UpdateContact from './UpdateContact';

function Routes() {
  return (
    <DocumentTitle title="Contacts">
      <Route path="/contacts" exact component={ContactsHome} />
      <Route path="/contacts/add" component={AddContact} />
      <Route path="/contacts/:id/show" component={ShowContact} />
      <Route path="/contacts/:id/edit" component={UpdateContact} />
      <Route path="/contacts/contact-lists/add" component={AddContactList} />
      <Route
        path="/contacts/contact-lists/:id/show"
        component={ShowContactList}
      />
    </DocumentTitle>
  );
}

export default Routes;
